/* eslint-disable eqeqeq */
import React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import FormParcelaNfe from '../form-parcela-nfe';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import api from '../../../services/api';
import Swal from 'sweetalert2';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginBottom: 5
    },
    tableWrapper: {
        maxHeight: 440,
        overflow: 'auto',
    },
    ocultaCampo: {
        display: "none",
    },
}));


export default function ListagemNfeParcela(props) {

    const { parcelasNota, adicionarParcela, removerParcela, inativo, autorizada } = props;
    const classes = useStyles();

    async function deletar(codigoParcela, indexParcela) {
        if (codigoParcela) {

            let dadosEnvio = {
                DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
                DBUSERNAME: localStorage.getItem("DBUSERNAME"),
                DBESQUEMA: localStorage.getItem("DBESQUEMA"),
                DBPID: localStorage.getItem("DBPID"),
                MANDNUMBER: localStorage.getItem("MANDNUMBER"),
                PROCNAME: "WEBSITE_NFPARCELA_DELETE",
                EMPNUMBER: localStorage.getItem("EMPNUMBER"),
                PCNRNFI: codigoParcela
            };

            const resposta = await api.post('/execute', dadosEnvio);

            if (resposta.data.CODIGO_ERRO == 0) {
                removerParcela(indexParcela);
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    type: 'success',
                    title: 'Item Removido'
                })
            }
        } else {
            removerParcela(indexParcela);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                type: 'success',
                title: 'Item Removido'
            })
        }

    }

    return (
        <>
            <Paper className={parcelasNota.length == 0 ? classes.ocultaCampo : classes.root}>
                <div className={classes.tableWrapper}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ação</TableCell>
                                <TableCell>Valor</TableCell>
                                <TableCell>Vencimento</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {parcelasNota.map((parcela, indexParcela) => (
                                <TableRow key={parcela.codigoItem}>
                                    <TableCell>
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <FormParcelaNfe
                                                    adicionarParcela={adicionarParcela}
                                                    removerParcela={removerParcela}
                                                    grid="true"
                                                    parcelaNfe={parcela}
                                                    indexParcela={indexParcela}
                                                    inativo={inativo}
                                                />
                                            </Grid>
                                            {!autorizada &&
                                                <Grid item xs={6}>
                                                    <IconButton aria-label="alterar"
                                                        onClick={() => deletar(parcela.codigoParcela, indexParcela)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Grid>
                                            }
                                        </Grid>
                                    </TableCell>
                                    <TableCell>{parcela.valor}</TableCell>
                                    <TableCell>{parcela.vencimento}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Paper>
        </>

    )
}